var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.$t("common.empty"))+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }